import {
	OverviewScore, ReviewScore
} from "@sabyr-dev/mist_core/model/datasource/score";
import { BindRecord } from "@sabyr-dev/mist_core/view/frontend/frontend";
import {
	CommonListView, CommonSettingsView
} from "@sabyr-dev/mist_core/view/impl/common";
import {
	OverviewChartView, OverviewSectionView
} from "@sabyr-dev/mist_core/view/impl/overview";
import {
	ReviewHeaderView,
	ReviewItemView, ReviewScoreView
} from "@sabyr-dev/mist_core/view/impl/review";
import { TestItemView } from "@sabyr-dev/mist_core/view/impl/test";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import {
	AcademyChartFrontend, AcademyItemFrontend, AcademyListFrontend,
	AcademyScoreFrontend, AcademySectionFrontend, AcademySettingsFrontend
} from "./frontend";
import {
	AcademyChartView, AcademyItemView, AcademyListView, AcademyScoreView,
	AcademySectionView, AcademySettingsView
} from "./view";
import { AcademyOverviewSummaryTable } from "../lib/overviewsummary";

export class AcademyCommonListView extends CommonListView<Product, Attempt, Quiz, Question> implements AcademyListView {
	frontend: AcademyListFrontend;

	displayLockedQuestions(freeQuestions: number, locked: boolean, baseColor: string): void {
		return this.frontend.displayLockedQuestions(freeQuestions, locked, baseColor);
	}

	displayQuestionResult(item: Question, status: 'correct' | 'incorrect' | 'unanswered', time: number): void {
		return this.frontend.displayQuestionResult(item, status, time);
	}
}

export class AcademyCommonSettingsView extends CommonSettingsView<Product, Attempt, Quiz, Question> implements AcademySettingsView {
	frontend: AcademySettingsFrontend;

	getBindSaveEmail(): BindRecord {
		return this.frontend.getBindSaveEmail();
	}

	getBindPartialResults(): BindRecord {
		return this.frontend.getBindPartialResults();
	}

	getBindRetryEmail(): BindRecord {
		return this.frontend.getBindRetryEmail();
	}

	getBindCheckEmail(): BindRecord {
		return this.frontend.getBindCheckEmail();
	}

	updateReportEmail(email: string): void {
		return this.frontend.updateReportEmail(email);
	}

	displayEmailModal(jQuery: JQueryStatic, count: number): void {
		return this.frontend.displayEmailModal(jQuery, count);
	}

	hideEmailModal(jQuery: JQueryStatic): void {
		return this.frontend.hideEmailModal(jQuery);
	}

	displayDoubleOptInModal(jQuery: JQueryStatic, email: string): void {
		return this.frontend.displayDoubleOptInModal(jQuery, email);
	}

	displayDoubleOptInRetry(): void {
		return this.frontend.displayDoubleOptInRetry();
	}

	displayDoubleOptInUnlock(): void {
		return this.frontend.displayDoubleOptInUnlock();
	}

	hideDoubleOptInModal(jQuery: JQueryStatic): void {
		return this.frontend.hideDoubleOptInModal(jQuery);
	}
}

export class AcademyOverviewChartView extends OverviewChartView<Product, Attempt, Quiz, Question> implements AcademyChartView {
	frontend: AcademyChartFrontend;

	getOverviewSummaryTable(jQuery: JQueryStatic): AcademyOverviewSummaryTable {
		return this.frontend.getOverviewSummaryTable(jQuery);
	}
}

export class AcademyOverviewSectionView extends OverviewSectionView<Product, Attempt, Quiz, Question> implements AcademySectionView {
	frontend: AcademySectionFrontend;

	displayHighScores(scores: OverviewScore<Attempt, Quiz>[]): void {
		return this.frontend.displayHighScores(scores);
	}
}

export class AcademyReviewItemView extends ReviewItemView<Product, Attempt, Quiz, Question> implements AcademyItemView {
	frontend: AcademyItemFrontend;

	displayTest(url: string): void {
		return this.frontend.displayTest(url);
	}
}

export class AcademyReviewHeaderView extends ReviewHeaderView<Product, Attempt, Quiz, Question> {
	displayTotalTime(time: number) {
		this.frontend.displayTotalTime(time);
	}
}

export class AcademyReviewScoreView extends ReviewScoreView<Product, Attempt, Quiz, Question> implements AcademyScoreView {
	frontend: AcademyScoreFrontend;

	displayReviewScoreTable(scores: ReviewScore[], total: ReviewScore): void {
		return this.frontend.displayReviewScoreTable(scores, total);
	}
}

export class AcademyTestItemView extends TestItemView<Product, Attempt, Quiz, Question> implements AcademyItemView {
	frontend: AcademyItemFrontend;

	displayTest(url: string): void {
		return this.frontend.displayTest(url);
	}
}
